<template>
  <div space :class="{ ready, refresh }">
    <SelectContent
      title="Humans In Space."
      :list="selectList"
      :active="active"
      @select="select"
    />
    <div class="cont cont1" v-if="active === 'intro'">
      <div class="c-ko">
        <div class="vision">
          <!-- <p class="bg-tit">
            Can we send sick people<br />
            into space?
          </p> -->
          <p class="tit">Humans In Space,<br />미래를 향한 보령의 여정은 계속됩니다.</p>
          <p class="txt txt1">
            2022년 ‘Care In Space 챌린지’와 2023년 ‘Humans In Space 프로그램’은 우리가 나아갈 방향, 해야할 일에 대해 명확한 지향점을 제시해준 계기였으며, 이 자리들을 통해 만나게 된 창의적인 기업들, 국내/외 우주분야 전문가 파트너들은 우리의 큰 자산이 되었습니다.
          </p>
          <p class="txt txt2">
            또한 2022년 인류 최초의 민간 우주정거장 건설을 추진 중인 미국 AXIOM SPACE에 전략적 투자를 진행하고, 2023년 AXIOM SPACE와의 국내 합작법인 ‘BRAX SPACE’를 설립하면서, 보령은 투자와 파트너십을 기반으로 우주 인프라를 향해 나아갈 기반을 마련했습니다.
          </p>
          <p class="txt txt3">
            개척정신으로 새로운 도전을 통해 그 결실을 미래 세대로 이어주는 것이 기업의 사명이라고 생각합니다. ‘우주개척 시대’를 맞아 보령은 차별화된 전략으로 미래의 운명을 가를 미개척 분야 우주를 향한 도전을 계속해 가겠습니다.
          </p>
          <div class="btn-area">
            <a href="https://humansinspaceofficial.com/" target="_blank" class="btn-next">HIS 웹사이트</a>
          </div>
        </div>
        <ul class="divs">
          <li>
            <p class="l-tit">Milestone Overview</p>
            <div>
              <p class="date">2022년 2월</p>
              <p class="txt">Axiom Space와 파트너십 체결</p>
            </div>
            <div>
              <p class="date">2022년 4월</p>
              <p class="txt">Care In Space (CIS) Challenge 개시</p>
            </div>
            <div>
              <p class="date">2022년 8월</p>
              <p class="txt">CIS Challenge Pitch Day (UCLA, 美 LA) 개최</p>
            </div>
            <div>
              <p class="date">2022년 12월</p>
              <p class="txt">CIS Challenge Demo Day (California Science Center, 美 LA) 개최</p>
            </div>
            <div>
              <p class="date">2022년 12월</p>
              <p class="txt">Axiom Space 전략적 투자</p>
            </div>
            <div>
              <p class="date">2023년 5월</p>
              <p class="txt">Humans In Space (HIS) Challenge 개시</p>
            </div>
            <div>
              <p class="date">2023년 10월</p>
              <p class="txt">HIS Symposium X AIAA ASCEND (Caesars Forum, 美 LV) 개최</p>
            </div>
            <div>
              <p class="date">2023년 12월</p>
              <p class="txt">보령-Axiom Space 합작법인 BRAX SPACE 설립</p>
            </div>
          </li>
          <!-- <li>
            <p class="l-tit">Our Partners</p>
            <div class="partners">
              <p class="tit">정부 및 연구 기관</p>
              <div class="logo">
                <i><img src="/images/mo/partner_1-1.png" alt=""></i>
                <i><img src="/images/mo/partner_1-2.png" alt=""></i>
                <i><img src="/images/mo/partner_1-3.png" alt=""></i>
                <i><img src="/images/mo/partner_1-4.png" alt=""></i>
                <i><img src="/images/mo/partner_1-5.png" alt=""></i>
              </div>
              <p class="tit">산학</p>
              <div class="logo">
                <i><img src="/images/mo/partner_2-1.png" alt=""></i>
                <i><img src="/images/mo/partner_2-2.png" alt=""></i>
                <i><img src="/images/mo/partner_2-3.png" alt=""></i>
                <i><img src="/images/mo/partner_2-4.png" alt=""></i>
                <i><img src="/images/mo/partner_2-5.png" alt=""></i>
                <i><img src="/images/mo/partner_2-6.png" alt=""></i>
                <i><img src="/images/mo/partner_2-7.png" alt=""></i>
                <i><img src="/images/mo/partner_2-8.png" alt=""></i>
              </div>
              <p class="tit">기업 및 투자자</p>
              <div class="logo">
                <i><img src="/images/mo/partner_3-1.png" alt=""></i>
                <i><img src="/images/mo/partner_3-2.png" alt=""></i>
                <i><img src="/images/mo/partner_3-3.png" alt=""></i>
                <i><img src="/images/mo/partner_3-4.png" alt=""></i>
                <i><img src="/images/mo/partner_3-5.png" alt=""></i>
                <i><img src="/images/mo/partner_3-6.png" alt=""></i>
                <i><img src="/images/mo/partner_3-7.png" alt=""></i>
                <i><img src="/images/mo/partner_3-8.png" alt=""></i>
                <i><img src="/images/mo/partner_3-9.png" alt=""></i>
                <i><img src="/images/mo/partner_3-10.png" alt=""></i>
                <i><img src="/images/mo/partner_3-11.png" alt=""></i>
                <i><img src="/images/mo/partner_3-12.png" alt=""></i>
                <i><img src="/images/mo/partner_3-13.png" alt=""></i>
                <i><img src="/images/mo/partner_3-14.png" alt=""></i>
                <i><img src="/images/mo/partner_3-15.png" alt=""></i>
              </div>
            </div>
          </li> -->
          <li>
            <div class="link">  
              <p class="tit">Connect with Humans In Space</p>
              <div>
                <a href="mailto:humansinspace@boryung.com" target="_blank" class="mail">
                  <span>E-mail</span>
                </a>
                <a href="https://humansinspaceofficial.com/" target="_blank" class="website">
                  <span>HIS Website</span>
                </a>
                <a href="https://www.instagram.com/humansinspace_official" target="_blank" class="instagram">
                  <span>Instagram</span>
                </a>
                <a href="https://www.facebook.com/humansinspace.official" target="_blank" class="facebook">
                  <span>Facebook</span>
                </a>
                <a href="https://www.linkedin.com/company/31282842/admin/" target="_blank" class="linkedin">
                  <span>LinkedIn</span>
                </a>
                <a href="https://www.youtube.com/@Humans_In_Space" target="_blank" class="youtube">
                  <span>YouTube</span>
                </a>
                <a href="https://twitter.com/humansinspace_" target="_blank" class="twitter">
                  <span>X (Twitter)</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="c-en">
        <div class="vision">
          <!-- <p class="bg-tit">
            Can we send sick people<br />
            into space?
          </p> -->
          <p class="tit">Humans In Space,<br />The Journey of Boryung Towards the Future Continues</p>
          <p class="txt txt1">
            The ‘2022 Care In Space Challenge’ and ‘2023 Humans In Space’ provided us with clear milestones, guiding our direction towards our mission. Through these initiatives, we have encountered innovative companies and experts in the domestic and international space industry who have now become our invaluable assets.
          </p>
          <p class="txt txt2">
            Furthermore, in 2022, we strategically invested in AXIOM SPACE, the key space infrastructure company constructing the world's first commercial space station. In 2023, we established ‘BRAX SPACE,’ a domestic joint venture with AXIOM SPACE. These investments and partnerships have laid the foundation for Boryung's advancement in developing the space infrastructure.
          </p>
          <p class="txt txt3">
            The mission of Boryung is to pass on the fruits of new challenges through pioneering spirit to future generations. As we embrace the era of space exploration, Boryung will continue to pursue uncharted territories in space with distinctive strategies to shape the future of humanity.
          </p>
          <div class="btn-area">
            <a href="https://humansinspaceofficial.com/" target="_blank" class="btn-next">Learn more about HIS</a>
          </div>
        </div>
        <ul class="divs">
          <li>
            <p class="l-tit">Milestone Overview</p>
            <div>
              <p class="date">Feb. 2022</p>
              <p class="txt">Partnership Signed with Axiom Space</p>
            </div>
            <div>
              <p class="date">Apr. 2022</p>
              <p class="txt">Care In Space (CIS) Challenge Commenced</p>
            </div>
            <div>
              <p class="date">Aug. 2022</p>
              <p class="txt">CIS Challenge Pitch Day (UCLA, Los Angeles, CA, U.S.)</p>
            </div>
            <div>
              <p class="date">Dec. 2022</p>
              <p class="txt">CIS Challenge Demo Day (California Science Center, Los Angeles, CA, U.S.)</p>
            </div>
            <div>
              <p class="date">Dec. 2022</p>
              <p class="txt">Strategic Investment in Axiom Space</p>
            </div>
            <div>
              <p class="date">May 2023</p>
              <p class="txt">Humans In Space (HIS) Challenge Commenced</p>
            </div>
            <div>
              <p class="date">Oct. 2023</p>
              <p class="txt">HIS Symposium X AIAA ASCEND (Caesars Forum, LV, U.S.)</p>
            </div>
            <div>
              <p class="date">Dec. 2023</p>
              <p class="txt">BRAX Space, the Joint Venture of Boryung & Axiom Space Established</p>
            </div>
          </li>
          <!-- <li>
            <p class="l-tit">Our Partners</p>
            <div class="partners">
              <p class="tit">Government Agencies & Institutes</p>
              <div class="logo">
                <i><img src="/images/mo/partner_1-1.png" alt=""></i>
                <i><img src="/images/mo/partner_1-2.png" alt=""></i>
                <i><img src="/images/mo/partner_1-3.png" alt=""></i>
                <i><img src="/images/mo/partner_1-4.png" alt=""></i>
                <i><img src="/images/mo/partner_1-5.png" alt=""></i>
              </div>
              <p class="tit">Academia</p>
              <div class="logo">
                <i><img src="/images/mo/partner_2-1.png" alt=""></i>
                <i><img src="/images/mo/partner_2-2.png" alt=""></i>
                <i><img src="/images/mo/partner_2-3.png" alt=""></i>
                <i><img src="/images/mo/partner_2-4.png" alt=""></i>
                <i><img src="/images/mo/partner_2-5.png" alt=""></i>
                <i><img src="/images/mo/partner_2-6.png" alt=""></i>
                <i><img src="/images/mo/partner_2-7.png" alt=""></i>
                <i><img src="/images/mo/partner_2-8.png" alt=""></i>
              </div>
              <p class="tit">Commercial Organizations</p>
              <div class="logo">
                <i><img src="/images/mo/partner_3-1.png" alt=""></i>
                <i><img src="/images/mo/partner_3-2.png" alt=""></i>
                <i><img src="/images/mo/partner_3-3.png" alt=""></i>
                <i><img src="/images/mo/partner_3-4.png" alt=""></i>
                <i><img src="/images/mo/partner_3-5.png" alt=""></i>
                <i><img src="/images/mo/partner_3-6.png" alt=""></i>
                <i><img src="/images/mo/partner_3-7.png" alt=""></i>
                <i><img src="/images/mo/partner_3-8.png" alt=""></i>
                <i><img src="/images/mo/partner_3-9.png" alt=""></i>
                <i><img src="/images/mo/partner_3-10.png" alt=""></i>
                <i><img src="/images/mo/partner_3-11.png" alt=""></i>
                <i><img src="/images/mo/partner_3-12.png" alt=""></i>
                <i><img src="/images/mo/partner_3-13.png" alt=""></i>
                <i><img src="/images/mo/partner_3-14.png" alt=""></i>
                <i><img src="/images/mo/partner_3-15.png" alt=""></i>
              </div>
            </div>
          </li> -->
          <li>
            <div class="link">  
              <p class="tit">Connect with Humans In Space</p>
              <div>
                <a href="mailto:humansinspace@boryung.com" target="_blank" class="mail">
                  <span>E-mail</span>
                </a>
                <a href="https://humansinspaceofficial.com/" target="_blank" class="website">
                  <span>HIS Website</span>
                </a>
                <a href="https://www.instagram.com/humansinspace_official" target="_blank" class="instagram">
                  <span>Instagram</span>
                </a>
                <a href="https://www.facebook.com/humansinspace.official" target="_blank" class="facebook">
                  <span>Facebook</span>
                </a>
                <a href="https://www.linkedin.com/company/31282842/admin/" target="_blank" class="linkedin">
                  <span>LinkedIn</span>
                </a>
                <a href="https://www.youtube.com/@Humans_In_Space" target="_blank" class="youtube">
                  <span>YouTube</span>
                </a>
                <a href="https://twitter.com/humansinspace_" target="_blank" class="twitter">
                  <span>X (Twitter)</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="cont cont2" v-if="active === 'cis'">
      <div class="c-ko">
        <div class="vision">
          <!-- <p class="tit">2022 Care In Space</p> -->
          <p class="tit">보령의 우주를 향한 첫 걸음, Care In Space</p>
          <p class="txt txt1">
            2022년 보령이 개최한 CIS Challenge는 최초의 Space Healthcare 스타트업 경진대회이자 엑셀러레이터 프로그램입니다. CIS 챌린지는 현재의 Humans In Space 프로그램의 시작점이자 보령의 우주사업을 향한 첫 발자국으로서의 의미가 있습니다.
          </p>
          <p class="txt txt2">
            보령은 CIS 챌린지를 통해 세계 각국의 다양한 아이디어를 보유한 스타트업을 대상으로 스페이스 헬스케어의 아이디어를 모집 및 검증했고, 6개의 최종 수상팀들은 10만 달러의 투자금을 비롯해 13주 동안 진행될 엑셀러레이터 프로그램 참여의 기회를 부여 받았습니다.
          </p>
        </div>
        <div class="c-cnt">
          <p class="t">Timeline</p>
          <div class="timeline">
            <ul class="sec1">
              <li class="c1"><p>Applications Open<br />April 18th, 2022</p></li>
              <li><p>AMA #1<br />May 23rd, 2022 (5-6pm PT)</p></li>
              <li><p>AMA #2<br />June 9th, 2022 (9-10am PT)</p></li>
              <li class="c1"><p>Applications Close<br />June 17th, 2022 (11:59pm PT)</p></li>
              <li><p>Finalists Selected<br />July 8th, 2022</p></li>
              <li class="c2"><p>Pitch Day<br />August 4th, 2022</p></li>
              <li class="under"><p>Accelerator Start<br />September 12th , 2022</p></li>
              <li class="under c2"><p>Demo Day<br />December 6th, 2022</p></li>
            </ul>
            <div class="sec2">
              <div><p>APPLICATION <br />WINDOW</p></div>
              <div><p>EVALUATION</p></div>
              <div><p>ACCELERATOR <br />PROGRAM</p></div>
            </div>
          </div>
        </div>
        <div class="c-cnt c-cnt2">
          <p class="t">2022 Demo Day</p>
          <div class="video">
            <video controls width="100%" poster="/images/mo/thumbnail_demo.png">
              <source :src="src_2022_video1" type="video/mp4">
              영상오류
            </video>
          </div>
        </div>
        <div class="c-cnt c-cnt3">
          <p class="t">2022 Pitch Day</p>
          <div class="video">
            <video controls width="100%" poster="/images/mo/thumbnail_pitch.png">
              <source :src="src_2022_video2" type="video/mp4">
              영상오류
            </video>
          </div>
        </div>
        <div class="c-cnt c-cnt4">
          <p class="t">2022 CIS Challenge Winners</p>
          <div class="winner">
            <div><img src="/images/mo/cis-winner1.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner2.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner3.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner4.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner5.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner6.jpg" alt=""></div>
          </div>
        </div>
        <div class="c-cnt c-cnt5">
          <p class="t">Collaboration</p>
          <div class="collaborate">
            <a href="https://www.axiomspace.com" target="_blank">
              <img src="/images/mo/cis-logo1.png" alt="Axiom Space logo">
            </a>
            <a href="https://starburst.aero" target="_blank">
              <img src="/images/mo/cis-logo2.png" alt="Starburst Aerospace logo">
            </a>
          </div>
        </div>
        <div class="c-cnt c-cnt6">
          <p class="t">Partners</p>
          <div class="partner">
            <i><img src="/images/mo/partner_cis-1.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-2.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-3.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-4.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-5.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-6.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-7.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-8.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-9.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-10.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-11.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-12.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-13.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-14.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-15.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-16.png" alt=""></i>
          </div>
        </div>
      </div>
      <div class="c-en">
        <div class="vision">
          <!-- <p class="tit">2022 Care In Space</p> -->
          <p class="tit">Care In Space, Boryung’s First Step Towards Space</p>
          <p class="txt txt1">
            The CIS Challenge, hosted by Boryung in 2022, is the world's first space healthcare startup competition and accelerator program. It serves as the foundation for the current Humans In Space program, signifying Boryung's initial step into space business ventures.
          </p>
          <p class="txt txt2">
            Through the CIS Challenge, Boryung enlisted and validated space healthcare ideas from startups worldwide with diverse ideas, and the six final winners were granted an investment of USD 100,000 and the opportunity to participate in a 13-week accelerator program.
          </p>
        </div>
        <div class="c-cnt">
          <p class="t">Timeline</p>
          <div class="timeline">
            <ul class="sec1">
              <li class="c1"><p>Applications Open<br />April 18th, 2022</p></li>
              <li><p>AMA #1<br />May 23rd, 2022 (5-6pm PT)</p></li>
              <li><p>AMA #2<br />June 9th, 2022 (9-10am PT)</p></li>
              <li class="c1"><p>Applications Close<br />June 17th, 2022 (11:59pm PT)</p></li>
              <li><p>Finalists Selected<br />July 8th, 2022</p></li>
              <li class="c2"><p>Pitch Day<br />August 4th, 2022</p></li>
              <li class="under"><p>Accelerator Start<br />September 12th , 2022</p></li>
              <li class="under c2"><p>Demo Day<br />December 6th, 2022</p></li>
            </ul>
            <div class="sec2">
              <div><p>APPLICATION <br />WINDOW</p></div>
              <div><p>EVALUATION</p></div>
              <div><p>ACCELERATOR <br />PROGRAM</p></div>
            </div>
          </div>
        </div>
        <div class="c-cnt c-cnt2">
          <p class="t">2022 Demo Day</p>
          <div class="video">
            <video controls width="100%" poster="/images/mo/thumbnail_demo.png">
              <source :src="src_2022_video1" type="video/mp4">
              video error
            </video>
          </div>
        </div>
        <div class="c-cnt c-cnt3">
          <p class="t">2022 Pitch Day</p>
          <div class="video">
            <video controls width="100%" poster="/images/mo/thumbnail_pitch.png">
              <source :src="src_2022_video2" type="video/mp4">
              video error
            </video>
          </div>
        </div>
        <div class="c-cnt c-cnt4">
          <p class="t">2022 CIS Challenge Winners</p>
          <div class="winner">
            <div><img src="/images/mo/cis-winner1.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner2.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner3.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner4.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner5.jpg" alt=""></div>
            <div><img src="/images/mo/cis-winner6.jpg" alt=""></div>
          </div>
        </div>
        <div class="c-cnt c-cnt5">
          <p class="t">Collaboration</p>
          <div class="collaborate">
            <a href="https://www.axiomspace.com" target="_blank">
              <img src="/images/mo/cis-logo1.png" alt="Axiom Space logo">
            </a>
            <a href="https://starburst.aero" target="_blank">
              <img src="/images/mo/cis-logo2.png" alt="Starburst Aerospace logo">
            </a>
          </div>
        </div>
        <div class="c-cnt c-cnt6">
          <p class="t">Partners</p>
          <div class="partner">
            <i><img src="/images/mo/partner_cis-1.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-2.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-3.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-4.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-5.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-6.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-7.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-8.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-9.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-10.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-11.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-12.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-13.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-14.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-15.png" alt=""></i>
            <i><img src="/images/mo/partner_cis-16.png" alt=""></i>
          </div>
        </div>
      </div>
    </div>
    <div class="cont cont3" v-if="active === 'his'">
      <div class="c-ko">
        <div class="vision">
          <!-- <p class="tit">2023 Humans In Space</p> -->
          <p class="tit">Care In Space에서 Humans In Space로</p>
          <p class="txt txt1">
            보령은 2022년 Space Healthcare 생태계 구축을 목표로 ‘Care In Space 챌린지’를 시작했습니다. 그리고 2023년, Space Healthcare를 넘어 주제의 범위와 파트너의 규모를 확장한 ‘Humans In Space 프로그램’을 출범했습니다.
          </p>
          <p class="txt txt2">
            HIS 프로그램은 ①인류의 우주 장기체류 과정에서 발생하는 문제들에 대한 솔루션과, 지구상의 문제 해결에 우주의 환경을 적용하는 신기술을 개발하는 글로벌 스타트업, ②관련된 분야를 연구하는 학교와 연구기관들, ③그리고 우주산업에 투자하는 투자자들 등이 한 데 모인 산업 생태계 플랫폼입니다.
          </p>
          <p class="txt txt3">
            보령은 유망한 기술과 연구에 선제적 투자를 해나가고, HIS 프로그램 내에서 자생적인 선순환이 이루어질 수 있도록 지원하면서 이 생태계를 더욱 견고하게 성장시켜갈 것입니다.
          </p>
        </div>
        <div class="c-cnt">
          <p class="t">Timeline</p>
          <div class="timeline">
            <img src="/images/mo/his-timeline.png" alt="">
          </div>
        </div>
        <div class="c-cnt c-cnt2">
          <p class="t">2023 Humans In Space:<br />The Extraordinary for the Ordinary</p>
          <div class="video">
            <iframe :src="src_2023_video2" frameborder="0"></iframe>
          </div>
        </div>
        <div class="c-cnt c-cnt3">
          <p class="t">2023 Humans In Space<br />Symposium Highlights</p>
          <div class="video">
            <iframe :src="src_2023_video1" frameborder="0"></iframe>
          </div>
        </div>
        <div class="c-cnt c-cnt4">
          <p class="t">2023 HIS Challenge Winners</p>
          <div class="winner">
            <p class="tit">Startups</p>
            <div><img src="/images/mo/his-winner1-1.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-2.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-3.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-4.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-5.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-6.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-7.jpg" alt=""></div>
          </div>
          <div class="winner">
            <p class="tit">Researchers</p>
            <div><img src="/images/mo/his-winner2-1.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-2.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-3.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-4.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-5.jpg" alt=""></div>
          </div>
        </div>
        <div class="c-cnt c-cnt5">
          <p class="t">2023 HIS Co-Hosts</p>
          <div class="collaborate">
            <a href="javascript:void(0)">
              <img src="/images/mo/his-logo1.png" alt="Axiom Space logo">
            </a>
            <a href="javascript:void(0)">
              <img src="/images/mo/his-logo2.png" alt="Axiom Space logo">
            </a>
            <a href="javascript:void(0)">
              <img src="/images/mo/his-logo3.png" alt="Starburst Aerospace logo">
            </a>
          </div>
        </div>
        <div class="c-cnt c-cnt6">
          <p class="t">Partners</p>
          <div class="partner">
            <i><img src="/images/mo/partner_his-1.png" alt=""></i>
            <i><img src="/images/mo/partner_his-13.png" alt=""></i>
            <i><img src="/images/mo/partner_his-15.png" alt=""></i>
            <i><img src="/images/mo/partner_his-2.png" alt=""></i>
            <i><img src="/images/mo/partner_his-3.png" alt=""></i>
            <i><img src="/images/mo/partner_his-4.png" alt=""></i>
            <i><img src="/images/mo/partner_his-5.png" alt=""></i>
            <i><img src="/images/mo/partner_his-6.png" alt=""></i>
            <i><img src="/images/mo/partner_his-7.png" alt=""></i>
            <i><img src="/images/mo/partner_his-16.png" alt=""></i>
            <i><img src="/images/mo/partner_his-8.png" alt=""></i>
            <i><img src="/images/mo/partner_his-14.png" alt=""></i>
            <i><img src="/images/mo/partner_his-9.png" alt=""></i>
            <i><img src="/images/mo/partner_his-10.png" alt=""></i>
            <i><img src="/images/mo/partner_his-11.png" alt=""></i>
            <i><img src="/images/mo/partner_his-12.png" alt=""></i>
          </div>
        </div>
      </div>
      <div class="c-en">
        <div class="vision">
          <!-- <p class="tit">2023 Humans In Space</p> -->
          <p class="tit">From Care In Space to Humans In Space</p>
          <p class="txt txt1">
            In 2022, Boryung found the ‘Care In Space Challenge’ to establish the Space Healthcare Ecosystem. In 2023, we launched the Humans In Space program, which expanded the scope of topics and partners beyond space healthcare.
          </p>
          <p class="txt txt2">
            The HIS program is an industrial ecosystem platform that constitutes ①global startups developing solutions for the challenges arising during humanity's long-term stay in space as well as new technologies leveraging the space environment to solve problems on Earth, ②academia and research institutes studying the relevant fields, and ③investors investing in the space industry.
          </p>
          <p class="txt txt3">
            Boryung will continue to grow this ecosystem by proactively investing in promising technologies and research and supporting a self-sustaining virtuous cycle within the HIS program.
          </p>
        </div>
        <div class="c-cnt">
          <p class="t">Timeline</p>
          <div class="timeline">
            <img src="/images/mo/his-timeline.png" alt="">
          </div>
        </div>
        <div class="c-cnt c-cnt2">
          <p class="t">2023 Humans In Space:<br />The Extraordinary for the Ordinary</p>
          <div class="video">
            <iframe :src="src_2023_video2" frameborder="0"></iframe>
          </div>
        </div>
        <div class="c-cnt c-cnt3">
          <p class="t">2023 Humans In Space<br />Symposium Highlights</p>
          <div class="video">
            <iframe :src="src_2023_video1" frameborder="0"></iframe>
          </div>
        </div>
        <div class="c-cnt c-cnt4">
          <p class="t">2023 HIS Challenge Winners</p>
          <div class="winner">
            <p class="tit">Startups</p>
            <div><img src="/images/mo/his-winner1-1.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-2.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-3.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-4.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-5.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-6.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner1-7.jpg" alt=""></div>
          </div>
          <div class="winner">
            <p class="tit">Researchers</p>
            <div><img src="/images/mo/his-winner2-1.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-2.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-3.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-4.jpg" alt=""></div>
            <div><img src="/images/mo/his-winner2-5.jpg" alt=""></div>
          </div>
        </div>
        <div class="c-cnt c-cnt5">
          <p class="t">2023 HIS Co-Hosts</p>
          <div class="collaborate">
            <a href="javascript:void(0)">
              <img src="/images/mo/his-logo1.png" alt="Axiom Space logo">
            </a>
            <a href="javascript:void(0)">
              <img src="/images/mo/his-logo2.png" alt="Axiom Space logo">
            </a>
            <a href="javascript:void(0)">
              <img src="/images/mo/his-logo3.png" alt="Starburst Aerospace logo">
            </a>
          </div>
        </div>
        <div class="c-cnt c-cnt6">
          <p class="t">Partners</p>
          <div class="partner">
            <i><img src="/images/mo/partner_his-1.png" alt=""></i>
            <i><img src="/images/mo/partner_his-13.png" alt=""></i>
            <i><img src="/images/mo/partner_his-15.png" alt=""></i>
            <i><img src="/images/mo/partner_his-2.png" alt=""></i>
            <i><img src="/images/mo/partner_his-3.png" alt=""></i>
            <i><img src="/images/mo/partner_his-4.png" alt=""></i>
            <i><img src="/images/mo/partner_his-5.png" alt=""></i>
            <i><img src="/images/mo/partner_his-6.png" alt=""></i>
            <i><img src="/images/mo/partner_his-7.png" alt=""></i>
            <i><img src="/images/mo/partner_his-16.png" alt=""></i>
            <i><img src="/images/mo/partner_his-8.png" alt=""></i>
            <i><img src="/images/mo/partner_his-14.png" alt=""></i>
            <i><img src="/images/mo/partner_his-9.png" alt=""></i>
            <i><img src="/images/mo/partner_his-10.png" alt=""></i>
            <i><img src="/images/mo/partner_his-11.png" alt=""></i>
            <i><img src="/images/mo/partner_his-12.png" alt=""></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectContent from "@/views/components/SelectContent";
export default {
  name: "space",
  components: { SelectContent },
  data() {
    return {
      ready: true,
      refresh: true,
      src_2022_video1: "/video/2022_cis_challenge_demo_day_highlight_v7 (1080p).mp4",
      src_2022_video2: "/video/2022_cis_challenge___highlight_final (1080p).mp4",
      src_2023_video1: "https://www.youtube.com/embed/063LLEL4UBY?rel=0",
      src_2023_video2: "https://www.youtube.com/embed/LlEzQxAxSN0?rel=0",
    };
  },
  mounted() {
    setTimeout(() => {
      this.ready = false;
    }, 100);7
    setTimeout(() => {
      this.refresh = false;
    }, 500);
  },
  computed: {
    active() {
      return this.$route.params.space;
    },
    selectList() {
      return [
        { key: "intro", label: "gnb.space.intro" },
        { key: "his", label: "gnb.space.his" },
        { key: "cis", label: "gnb.space.cis" },
      ];
    },
  },
  watch: {
    active() {
      this.refresh = true;
      setTimeout(() => {
        this.refresh = false;
      }, 200);
    },
  },
  methods: {
    select(space) {
      if (this.active === space) return;
      this.$router.push({ params: { space } });
    },
  },
};
</script>

<style lang="less">
@import "~@/less/proj";
@use-rem: true;
@rem: 32;

[space] {
  .fs(0);
  .p(0, 70);
  .rel;
  .mt(140);
  .pb(200);
  .-box;
  [select-cont] {
    .pl(20);
    .-box;
  }
  .mo {
    .ib;
  }
  .web {
    .hide;
  }
  &:after {
    .cnt;
    .wh(100vw, 147.87vw);
    background: url("/images/pc/care-bg1.png") center top / 100% auto no-repeat;
    .abs;
    .lt(0, -280);
    z-index: -1;
  }
  .cont {
    // .tc;
    .txt {
      text-align: justify;
    }
    .vision {
      .mb(120);
      .bg-tit {
        .fs(54);
        .lh(48);
        .bold;
        color: #e3d7cb;
        .ls(-0.05em);
        .mb(36);
      }
      .tit {
        .fs(36);
        .lh(48);
        .medium;
        .ls(-0.05em);
        // .tc();
        .mb(60);
      }
      .txt {
        .fs(18);
        .lh(36);
        .medium;
        .mb(35);
      }
    }
    li .l-tit,
    .c-cnt .t{
      .fs(36);
      .semi-bold;
      .ls(-0.05em);
      .tc();
      .wf();
      .ib;
      .rel;
      .mb(54);
      &:before{
        .cnt;
        .bgc(#e3d7cb);
        .wh(300, 1);
        .abs;
        .lt(0, 50%);
        z-index: -1;
      }
      &:after {
        .cnt;
        .bgc(#e3d7cb);
        .wh(300, 1);
        .abs;
        .rt(0, 50%);
        z-index: -1;
      }
    }
    .video{
      position: relative;
      padding-bottom: 56.25%;
      height: 0;
      iframe{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
    .winner{
      .flex-wrap();
      justify-content: center;
      gap: 10px;
      +.winner{
        .mt(60);
      }
      .tit{
        flex: 0 0 100%;
        .semi-bold();
        .fs(20);
        .tl();
        .mb(20);
      }
      >div{
        flex: 0 0 calc(33.333% - 20px / 3);
        .-box();
        .-a(#dedede);
        .tc();
        img{
          .max-w(100%);
        }
      }
    }
    .collaborate{
      display: grid;
      .justify-center();
      gap: 1.5rem 0;
      .tc();
      a{
        .h(40);
        .-box();
        .rel();
        img{
          .max-h(100%);
          .abs();
          .l(50%);
          .t(50%);
          .t-xyc();
        }
      }
    }
    .partner{
      .flex();
      .flex-center();
      .flex-wrap();
      gap: 1rem 0;
      i{
        flex: 0 0 25%;
        .w(25%);
        .tc();
        img{
          .max-w(100%);
        }
      }
    }
    .btn-area{
      .mt(60);
      .tc();
      .btn-next, .btn-prev{
        .ib();
        .fs(20);
        .bold;
        .lh(20);
        .tl();
        .w();
        .min-w(200);
        .-a(#2d2d2f);
        .p(20, 90, 20, 30);
        .rel();
        transition: background-color 0.5s;
        &:after {
          .cnt;
          .wh(35, 20);
          .contain("/images/mo/arr-r.png");
          .abs;
          .rb(30, 20);
        }
        &:hover {
          color: #fff;
          .bgc(#333132);
          &:after {
            .cnt;
            .contain("/images/mo/arr-r-w.png");
          }
        }
      }
    }
    &.cont1 {
      // .tc;
      .divs {
        li {
          .pb(100);
          .-box;
          &:last-child{
            .pb(0);
          }
          .txt {
            .fs(24);
            .ls(-0.05em);
            .lh(30);
          }
          &:nth-child(1) {
            .tl;
            .l-tit {
              .block;
              .mh-c;
              .tc;
            }
            > div {
              // .w(650);
              // .mh-c;
              // .pl(20);
              .-box;
              .mb(10);
            }
            .date,
            .txt {
              .fs(18);
              .lh(24);
              .ib;
              .vat;
              .ls(-0.05em);
              .tl();
            }
            .date {
              .w(150);
            }
            .txt {
              .w(calc(100% - 4.6875rem));
              .keep-all;
            }
          }
          .partners{
            .tit{
              .fs(18);
              .tl();
              .mb(20);
            }
            .logo{
              .flex();
              .flex-ai();
              .flex-jc(flex-start);
              .flex-wrap();
              gap: 0.5rem 0;
              .mb(60);
              i{
                img{
                  .max-w(100%);
                  .max-h(100%);
                }
              }
              &:nth-of-type(1){
                .flex-jc(space-between);
                i{
                  .h(74);
                }
              }
              &:nth-of-type(2){
                i{
                  flex: 0 0 25%;
                  .h(62);
                  .tl();
                }
              }
              &:nth-of-type(3){
                .flex-jc(space-between);
                gap: 0.5rem 1.2rem;
                .mb(0);
                i{
                  .h(64);
                  &:last-child{
                    flex: auto;
                    .tl(); 
                  }
                }
              }
            }
          }
          .link{
            .tc();
            .-t(#e3d7cb);
            .pt(80);
            .tit{
              .semi-bold();
              .fs(26);
              .mb(50);
            }
            >div{
              a{
                .block();
                .max-w(230);
                // .h(56);
                .-a(#dedede);
                .p(20, 30, 20, 60);
                .tc();
                .rel();
                .m(0, auto, 10);
                transition: background 0.25s;
                &::before{
                  .cnt();
                  .w(30);
                  .h(30);
                  .abs();
                  .lt(30, 50%);
                  .t-yc();
                }
                &.mail{
                  &::before{
                    .bg("/images/mo/care-icon-mail.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                &.website{
                  &::before{
                    .bg("/images/mo/care-icon-web.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                &.instagram{
                  &::before{
                    .bg("/images/mo/care-icon-instagram.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                &.facebook{
                  &::before{
                    .bg("/images/mo/care-icon-facebook.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                &.linkedin{
                  &::before{
                    .bg("/images/mo/care-icon-linkedin.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                &.youtube{
                  &::before{
                    .bg("/images/mo/care-icon-youtube.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                &.twitter{
                  &::before{
                    .bg("/images/mo/care-icon-twitter.png", center, center);
                    .bg-s(auto, 100%);
                  }
                }
                span{
                  .semi-bold();
                  .fs(17);
                  .lh(17);
                }
                &:hover{
                  .bgc(#2C2C2C);
                  &::before{
                    filter: invert(1) brightness(1.5);
                  }
                  span{
                    .c(#fff);
                  }
                }
              }
            }
          }
        }
      }
    }
    &.cont2{
      .timeline{
        .pb(130px);
        .sec1{
          .w(calc(100% - 9px));
          .-b(#e3d7cb, @v:3px);
          .flex();
          .items-end();
          .rel();
          li{
            flex: 1;
            .fs(14);
            .semi-bold();
            .c(#2d2d2f);
            .rel();
            .-l(#e3d7cb, 2px);
            .ml(8px);
            &:before{
              .cnt();
              .wh(18px, 18px);
              .bgc(#e3d7cb);
              .br(50%);
              .abs();
              .l(-10px);
              .b(-11px);
            }
            p{
              .bgc(#fff);
              .pb(5px);
              .ml(-10px);
            }
            &:nth-child(1),
            &:nth-child(4),
            &:nth-child(6){
              .h(160px);
            }
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(5){
              .h(105px);
            }
            &:nth-child(7){
              .w(20%);
              .h(140px);
              .abs();
              .b(-143px);
              .r(14.285%);
            }
            &:nth-child(8){
              .h(180px);
              .b(-183px);
            }
            &.under{
              border-left: none;
              .-r(#e3d7cb, 2px);
              &:before{
                .l(auto);
                .r(-10px);
                .b(auto);
                .t(-11px);
              }
              p{
                .tr();
                .m();
                .p(5px, 0, 0);
                .abs();
                .r(-10px);
                .b(0);
              }
            }
            &.c1{
              .c(#9f7c5a);
            }
            &.c2{
              .c(#c82a5e);
              .-c(#b62e56);
              &:before{
                .bgc(#b62e56);
              }
            }
          }
        }
        .sec2{
          .flex();
          gap: 5px;
          .mt(15px);
          >div{
            .table();
            .tc();
            .bgc(rgba(#f0eae5, 0.8));
            .p(7px);
            z-index: 1;
            &:nth-child(1){
              flex: 4;
            }
            &:nth-child(2){
              flex: 1;
            }
            &:nth-child(3){
              flex: 2;
            }
            p{
              .fs(13);
              .c(#9a8d80);
              br{
                display: none;
              }
            }
          }
        }
      }
      .collaborate{
        grid-template-columns: repeat(2, 1fr);
      }
    }
    &.cont3{
      .timeline{
        img{
          .max-w(100%);
        }
      }
      .collaborate{
        grid-template-columns: repeat(3, 1fr);
        a{
          cursor: default;
          &:first-child img{
            .max-h(60%);
          }
        }
      }
    }
    &.cont2, &.cont3 {
      .p(0, 10);
      .-box;
      .c-cnt {
        .mt(128);
        &.c-cnt2, &.c-cnt3{
          .mt(100);
        }
      }
    }
  }

  h2,
  .select-box,
  .cont .bg-tit,
  .cont .tit,
  .cont .txt,
  .cont .btn-area,
  .divs li,
  .cont2 .txt,
  .cont3 .txt,
  .c-cnt,
  .care-logo {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1s, transform 1s;
    transition-timing-function: ease-out;
  }
  .select-box {
    transition-delay: 0.8s;
  }
  .cont .bg-tit {
    transition-delay: 1.1s;
  }
  .cont1 {
    .tit {
      transition-delay: 1.4s;
    }
    .txt {
      &.txt1 {
        transition-delay: 1.7s;
      }
      &.txt2 {
        transition-delay: 2s;
      }
      &.txt3 {
        transition-delay: 2.3s;
      }
    }
    .btn-area{
      transition-delay: 2.6s;
    }
    .divs li {
      &:nth-child(1) {
        transition-delay: 3s;
      }
      &:nth-child(2) {
        transition-delay: 3.3s;
      }
      &:nth-child(3) {
        transition-delay: 3.6s;
      }
    }
  }
  .cont2 {
    .tit {
      &:first-child{
        transition-delay: 0.9s;
      }
      transition-delay: 1.1s;
    }
    .txt { 
      &.txt1 {
        transition-delay: 1.4s;
      }
      &.txt2 {
        transition-delay: 1.7s;
      }
    }
    .c-cnt {
      transition-delay: 2.2s;
    }
    .c-cnt2 {
      transition-delay: 2.5s;
    }
    .c-cnt3 {
      transition-delay: 2.8s;
    }
    .c-cnt4 {
      transition-delay: 3.1s;
    }
    .c-cnt5 {
      transition-delay: 3.4s;
    }
    .c-cnt6 {
      transition-delay: 3.7s;
    }
  }
  .cont3 {
    .tit {
      &:first-child{
        transition-delay: 0.9s;
      }
      transition-delay: 1.1s;
    }
    .txt { 
      &.txt1 {
        transition-delay: 1.4s;
      }
      &.txt2 {
        transition-delay: 1.7s;
      }
      &.txt3 {
        transition-delay: 2.0s;
      }
    }
    .c-cnt {
      transition-delay: 2.4s;
    }
    .c-cnt2 {
      transition-delay: 2.7s;
    }
    .c-cnt3 {
      transition-delay: 3.0s;
    }
    .c-cnt4 {
      transition-delay: 3.3s;
    }
    .c-cnt5 {
      transition-delay: 3.6s;
    }
    .c-cnt6 {
      transition-delay: 3.9s;
    }
  }

  &.ready {
    h2,
    .select-box,
    .cont .bg-tit,
    .cont .tit,
    .cont .txt,
    .cont .btn-area,
    .divs li,
    .cont2 .txt,
    .cont3 .txt,
    .c-cnt,
    .care-logo {
      opacity: 0;
      transform: translateY(100px);
    }
  }
  &.refresh {
    h2,
    .select-box,
    .cont .bg-tit,
    .cont .tit,
    .cont .txt,
    .cont .btn-area,
    .divs li,
    .cont2 .txt,
    .cont3 .txt,
    .c-cnt,
    .care-logo {
      transition: opacity 0s, transform 0s;
      transition-delay: 0s;
      opacity: 0;
      transform: translateY(100px);
    }
  }
  [select-cont] .select-box{
    .min-w(420);
    s {
      .hide;
    }
  }
}

#app {
  &.en [space] {
    .p(0, 50, 140);
    [select-cont] {
      .pl(20);
      .-box;
    }
    .cont{
      &.cont1 {
        .divs li {
          > div {
            .pl(0);
          }
        }
      }
      // .c-en .vision .tit {
      //   .fs(54);
      //   .tc;
      //   // .bold;
      // }
    }
  }
}
@media screen and(min-width: 1240px) {
  [space] {
    .max-w(1240);
    .p(180, 40, 200, 60) !important;
    .-box;
    .mh-c;
    .mt(0);
    [select-cont] {
      .pl(0);
      .select-box {
        .r(0);
      }
    }
    .mo {
      .hide;
    }
    .web {
      .ib;
    }
    &:after {
      .h(984);
      background: url("/images/pc/care-bg1.png") center top no-repeat;
      .lt(50%, -109);
      .ml(-50vw);
    }
    .cont {
      .mt(20);
      .w(860);
      .vision {
        .tit {
          .mb(40);
          .tl();
        }
        .txt {
          .keep-all;
        }
      }
      li .l-tit,
      .c-cnt .t {
        // .wf();
        .mb(60);
        &:before{
          .wh(200, 1);
        }
        &:after {
          .wh(200, 1);
        }
      }
      &.cont2, &.cont3 {
        .p(0);
        .c-cnt {
          .link{
            p{
              .fs(20);
            }
          }
          &.c-cnt4{
            .t{
              &:before{
                .wh(120, 1);
              }
              &:after {
                .wh(120, 1);
              }
            }
          }
        }
      }
    }
  }
  #app {
    &.en [space] {
      [select-cont] {
        .pl(0);
      }
      .cont {
        .c-en .vision .tit {
          .tl;
        }
      }
    }
  }
}
@media screen and (max-width: 1024px) and (min-width: 768px) {
  // [space] .cont .collaborate a img{
  //   .max-h(95%);
  //   .max-w(90%);
  // }
  [space] .cont .collaborate a{
    .h(4vw);
  }
}
@media screen and(max-width: 767px) {
  [space]{
    &:after {
      background-image: url("/images/mo/care-bg1.png");
    }
    .cont{
      li .l-tit,
      .c-cnt .t {
        &:before{
          .w(10vw);
        }
        &:after {
          .w(10vw);
        }
      }
      .collaborate{
        a{
          .h(5vw);
        }
      }
      .partner{
        i{
          img{
            .max-w(100%);
            transform: scale(0.8);
          }
        }
      }
      &.cont1{
        .divs li{
          .partners{
            .logo{
              justify-content: flex-start !important;
              gap: 1rem !important;
              i{
                flex: 0 0 calc(20% - 4rem/5) !important;
                // .tc() !important;
              }
              &:nth-of-type(2){
                i{
                  flex: 0 0 calc(25% - 3rem/4) !important;
                }
              }
            }
          }
        }
      }
      &.cont2{
        .timeline{
          .flex();
          flex-direction: row-reverse;
          gap: 20px;
          .pb(25px);
          .sec1{
            flex: 2;
            .block();
            .w(auto);
            .-b();
            .rel();
            &:before{
              .cnt();
              .wh(3px, 100%);
              .bgc(#e3d7cb);
              .abs();
              .l(0);
              .t(3px);
            }
            li{
              .fs(22);
              .h(5rem);
              .pl(40px);
              .-l();
              .m();
              p{
                .bgc();
                .ml(0);
              }
              &:before{
                .wh(12px, 12px);
                .l(-4px);
                .t(3px);
                .b(auto);
              }
              &:after{
                .cnt();
                .wh(35px, 2px);
                .bgc(#e3d7cb);
                .abs();
                .l(0);
                .t(8px);
              }
              &:nth-child(1),
              &:nth-child(2),
              &:nth-child(3),
              &:nth-child(4),
              &:nth-child(5),
              &:nth-child(6),
              &:nth-child(7){
                .h(5rem);
              }
              &:last-child{
                .h(12px);
              }
              &.under{
                width: auto;
                .-r();
                .rel();
                .b(auto);
                .r(auto);
                &:before{
                  left: -4px;
                  right: auto;
                  bottom: auto;
                  top: 3px;
                }
                p{
                  .tl();
                  .pt(0);
                  .static();
                }
              }
              &.c2{
                &:after{
                  .bgc(#b62e56);
                }
              }
            }
          }
          .sec2{
            flex: 1;
            // .flex-center();
            flex-direction: column;
            .m();
            >div{
              .fs(16);
              p{
                .cell();
                .vam();
                br{
                  display: initial;
                }
              }
            }
          }
        }
      }
      &.cont3{
        .collaborate{
          // grid-template-columns: repeat(2,1fr);
          a{
            &:first-child{
              // grid-column-start: 1;
              // grid-column-end: 3;
            }
          }
        }
      }
    }
  }
}
@media screen and(max-width: 480px) {
  [space] .cont{
    .partner{
      i{
        flex: 0 0 50%;
        .w(50%);
      }
    }
    .collaborate{
      a{
        .h(6vw);
      }
    }
  }
}
</style>
